import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { Alert } from "@tine/designsystem-ui-react";
import { cn } from "@tine/designsystem-utils";
import { observer } from "mobx-react-lite";

import type { WarningFields } from "../common/types/cmsTypes";

type WarningProps = {
   warning: WarningFields;
   className?: string;
};

const AlertMessage = ({ warning, className }: WarningProps) => {
   const Message = () => documentToReactComponents(warning.message);

   let variant: "warning" | "information" | "error" | "success" | undefined;

   switch (warning.theme) {
      case "Warning":
         variant = "error";
         break;
      case "Information":
         variant = "information";
         break;
      case "Important":
         variant = "warning";
         break;
      default:
         variant = "information";
   }

   const classNames = cn([
      "justify-center px-0 [&>div>div>div>div>p]:mb-0 [&>div]:max-w-[--main-column-max-width]",
      "[&>div]:px-3 sm:[&>div]:px-4",
      className
   ]);

   return (
      <Alert fullWidth={true} variant={variant} showCloseButton={false} className={classNames}>
         <Message />
      </Alert>
   );
};
export default observer(AlertMessage);
